import Store from "@/store/index.js";
import axios from 'axios';
const domain = Store.state.domain;

export default {
    async ListadoSolicitudes(uslogin) {
        var formData = new FormData();
        formData.append("uslogin", uslogin);
        let response = await axios.post(`${domain.domainNameForApi}PreAlta/ListadoSolicitudes`, formData);
        return response.data;
    },
    async AutorizarSolicitud(pauid, obs, uslogin, pauapellidoP, pauapellidoM, paunombre, paupuesto, respuesta, pendAutorizacion) {
        var formData = new FormData();
        formData.append("pauid", pauid);
        formData.append("obs", obs);
        formData.append("uslogin", uslogin);
        formData.append("pauapellidoP", pauapellidoP);
        formData.append("pauapellidoM", pauapellidoM);
        formData.append("paunombre", paunombre);
        formData.append("paupuesto", paupuesto);
        formData.append("respuesta", respuesta);
        formData.append("pendAutorizacion", pendAutorizacion);

        let response = await axios.post(`${domain.domainNameForApi}PreAlta/AutorizarSolicitud`, formData);
        return response.data;
    },
    async valFirmaElectronica(usfirma) {
        var formData = new FormData();
        formData.append("usfirma", usfirma);
        let response = await axios.post(`${domain.domainNameForApi}ExpJur/ValFirmaElectronica`, formData);
        return response.data;
    },
    async DetalleSolicitud(pauid) {
        var formData = new FormData();
        formData.append("pauid", pauid);
        let response = await axios.post(`${domain.domainNameForApi}PreAlta/DetalleSolicitud`, formData);
        return response.data[0];
    },
}